import { useState } from 'react'

import * as Styled from './styled'

import { t } from 'i18next'
import { shareLink } from 'utils/share'
import PopupSectionRow from 'components/popup/PopupSectionRow'
import { Typography } from '@mui/material'
import { MiscText } from 'components/login/styled'

export interface InviteLinkBadgeProps {
  link: string
}

export default function InviteLinkBadge(props: InviteLinkBadgeProps) {
  if (!props.link) {
    return <></>
  }

  return (
    <Styled.InviteLinkBadge padding={4} gap={4}>
      <PopupSectionRow
        title={<Typography fontWeight={600}>{t('inviteMembers')}</Typography>}
        value=""
      />
      <InviteLinkRow width="90% !important" link={props.link} />
      <MiscText fontSize={'12px'}>{t('anyoneWithLink')}</MiscText>
    </Styled.InviteLinkBadge>
  )
}

interface InviteLinkRowProps {
  link: string
  text?: string
  textSize?: string
  allowScroll?: boolean
  width?: string
  height?: string
}

export function InviteLinkRow(props: InviteLinkRowProps) {
  const [linkCopyTitle, setLinkCopyTitle] = useState<string>(
    `${t('copyToClipboard')}`
  )

  async function handleCopyAction() {
    try {
      setLinkCopyTitle(`${t('copied')}`)
      await navigator.clipboard.writeText(props.text ?? props.link)
      shareLink(props.text ?? props.link)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <Styled.InviteLinkContainer
      height={props.height ?? '30px'}
      width={props.width}
      container
      dir="ltr"
    >
      <Styled.LinkContent
        style={{ fontSize: props.textSize ? props.textSize : '14px' }}
        {...props}
      >
        {props.text ?? props.link}
      </Styled.LinkContent>
      <Styled.CopyLinkButton onClick={handleCopyAction}>
        {linkCopyTitle}
      </Styled.CopyLinkButton>
    </Styled.InviteLinkContainer>
  )
}
